import { Location } from '@angular/common'
import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router } from '@angular/router'
import { Objects } from '../../../server/src/shared-with-client/object-definitions'
import { ParseService } from './parse.service'

type DataRoles = Objects.Role.Any[]

@Injectable()
export class AuthGuardService implements CanLoad, CanActivate {
    constructor(
        public parseService: ParseService,
        public router: Router,
        private location: Location
    ) {}

    async canLoad(route: Route): Promise<boolean> {
        if (!route.data) {
            return false
        }

        const roles: DataRoles = route.data.roles
        const canAccess = await this.canAccess(roles)
        return canAccess
    }

    async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
        const roles: DataRoles = route.data.roles
        const accessAllowed = await this.canAccess(roles)

        return accessAllowed
    }

    private async canAccess(roles: DataRoles): Promise<boolean> {
        if (!roles) {
            return true
        }

        for (const role of roles) {
            const accessAllowed = await this.parseService.roleService.doesUserHavePermission(role)
            if (accessAllowed) {
                return true
            }
        }

        if (!this.parseService.roleService.userRoles.hasRoles()) {
            const queryParams: { redirectUrl?: string } = {}
            const locationPath = this.location.path()

            if (locationPath) {
                queryParams.redirectUrl = locationPath
            }
            this.router.navigate(['/login'], { queryParams })
        }

        return false
    }
}
